window.__VUE_PROD_DEVTOOLS__ = false;
window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import { Amplify } from "aws-amplify";
import { Hub } from "aws-amplify/utils";
loadFonts();

async function initApp() {
  Amplify.configure({
    Auth: {
      Cognito: {
        identityPoolId: "ap-south-1:50804f7e-1fec-4591-b570-cd06f6aa8e63",
        userPoolId: "ap-south-1_4YnEAqVnH",
        userPoolClientId: "c41r8r5r642v12i189h8dhsh4",
        loginWith: {
          email: true,
        },
        signUpVerificationMethod: "code",
      },
    },
    API: {
      GraphQL: {
        endpoint:
          "https://ufdzzokf6vcf3oqmyig4xlabqa.appsync-api.ap-south-1.amazonaws.com/graphql",
        region: "ap-south-1",
        defaultAuthMode: "userPool",
      },
    },
    Storage: {
      S3: {
        bucket: "skilterweb-questions-bulk-upload-dev",
        region: "ap-south-1",
      },
    },
  });
  Hub.listen("auth", ({ payload }) => {
    switch (payload.event) {
      case "signedIn":
        console.log("user have been signedIn successfully.");
        break;
      case "signedOut":
        console.log("user have been signedOut successfully.");
        break;
      case "tokenRefresh":
        console.log("auth tokens have been refreshed.");
        break;
      case "tokenRefresh_failure":
        console.log("failure while refreshing auth tokens.");
        router.push("/");
        break;
      case "signInWithRedirect":
        console.log("signInWithRedirect API has successfully been resolved.");
        break;
      case "signInWithRedirect_failure":
        console.log("failure while trying to resolve signInWithRedirect API.");
        break;
      case "customOAuthState":
        logger.info("custom state returned from CognitoHosted UI");
        break;
    }
  });
}
initApp().then(() => {
  createApp(App).use(router).use(store).use(vuetify).mount("#app");
});
